<div class="modal-header" *ngIf="!!availability">
  <h4 class="modal-title mt-0" id="modal-basic-title">
    {{ product?.extra?.gme?.displayId || product?.id }} - {{ product?.extra?.gme?.displayName || product?.name }}
    <br>
    <span translate>FUTURE</span>&nbsp;
    <small>
      <span translate>AVAILABILITY</span>
      <span> {{ availability.currentAvailability || 0 | number:'':localeLang }} <span translate>
        <lib-gung-meta-output
          [value]="availability.unitOfMeasure || 'PCS'"
          [suppressLabel]="true"
          metadataTable="unitsOfMeasure"
          metaOptionName="name"
          [showOnlyText]="true"
          [showIfNotFound]="true"
        ></lib-gung-meta-output>
      </span></span> /
      <span translate>MAX_FUTURE</span>&nbsp;<span
      *ngIf="availability?.maxFutureStock === 100000; else showMaxFutureStock"
      translate
    >STOCK_REPLENISHMENT</span
    >
      /
      <ng-template #showMaxFutureStock
      >{{ availability.maxFutureStock || 0 | number:'':localeLang }} <span translate>
          <lib-gung-meta-output
            [value]="availability.unitOfMeasure || 'PCS'"
            [suppressLabel]="true"
            metadataTable="unitsOfMeasure"
            metaOptionName="name"
            [showOnlyText]="true"
            [showIfNotFound]="true"
          ></lib-gung-meta-output>
        </span></ng-template
      >
      <span translate>STOCK</span>
      <span> {{ availability.currentStock || 0 | number:'':localeLang }} <span translate>
        <lib-gung-meta-output
          [value]="availability.unitOfMeasure || 'PCS'"
          [suppressLabel]="true"
          metadataTable="unitsOfMeasure"
          metaOptionName="name"
          [showOnlyText]="true"
          [showIfNotFound]="true"
        ></lib-gung-meta-output>
      </span></span>
    </small>
  </h4>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">
  <lib-gung-tabset [destroyOnHide]="false">
    <lib-gung-tab title="{{ 'BREAKDOWN' | translate }}">
      <ng-template libGungTabContent>
        <table class="table table-striped">
          <thead class="table-dark">
          <tr>
            <th scope="col" translate>DATE</th>
            <th scope="col" translate>ITEMS_AVAILABLE</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let availabilitie of availability.extra.availabilities | keyvalue">
            <td>{{ parseDate(availabilitie.key) | date: dateUtilService.dateFormat }}</td>
            <td>
              {{
                availabilitie.value > 0
                  ? availabilitie.value === 100000
                    ? ('STOCK_REPLENISHMENT' | translate)
                    : (availabilitie.value | number:'':localeLang)
                  : ('NO_AVAILABILITY' | translate)
              }}
              <span *ngIf="availabilitie.value > 0 && availabilitie.value !== 100000" class="text-lowercase" translate>
                     <lib-gung-meta-output
                       [value]="availability.unitOfMeasure || 'PCS'"
                       [suppressLabel]="true"
                       metadataTable="unitsOfMeasure"
                       metaOptionName="name"
                       [showOnlyText]="true"
                       [showIfNotFound]="true"
                     ></lib-gung-meta-output>
                   </span>
            </td>
          </tr>
          </tbody>
        </table>
      </ng-template>
    </lib-gung-tab>
    <lib-gung-tab title="{{ 'BATCHES' | translate }}" *ngIf="availability.extra?.batches?.length > 0">
      <ng-template libGungTabContent>
        <table class="table table-striped">
          <thead class="table-dark">
          <tr>
            <th scope="col" translate>BATCH</th>
            <th scope="col" translate>ITEMS_AVAILABLE</th>
            <th scope="col" translate>BATCH_PIECES</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let availabilitie of availability.extra.batches">
            <td>{{ availabilitie.batchId }}</td>
            <td>
              {{
                availabilitie.currentAvailability > 0
                  ? availabilitie.value === 100000
                    ? ('STOCK_REPLENISHMENT' | translate)
                    : (availabilitie.currentAvailability | number:'':localeLang)
                  : ('NO_AVAILABILITY' | translate)
              }}
              <span *ngIf="availabilitie.currentAvailability > 0" class="text-lowercase" translate>
                     <lib-gung-meta-output
                       [value]="availability.unitOfMeasure || 'PCS'"
                       [suppressLabel]="true"
                       metadataTable="unitsOfMeasure"
                       metaOptionName="name"
                       [showOnlyText]="true"
                       [showIfNotFound]="true"
                     ></lib-gung-meta-output>
                   </span>
            </td>
            <td>
              <ng-container *ngIf="availabilitie.pieces">
                <div class="row">
                  <div class="col-auto batch-pieces-key-container">
                    <ng-container *ngFor="let piece of availabilitie.pieces">
                      <span>{{ piece.pieceId }}</span> <br />
                    </ng-container>
                  </div>
                  <div class="col batch-pieces-value-container">
                    <ng-container *ngFor="let piece of availabilitie.pieces">
                      ({{ piece.currentAvailability }} <span class="text-lowercase" translate>
                     <lib-gung-meta-output
                       [value]="availability.unitOfMeasure || 'PCS'"
                       [suppressLabel]="true"
                       metadataTable="unitsOfMeasure"
                       metaOptionName="name"
                       [showOnlyText]="true"
                       [showIfNotFound]="true"
                     ></lib-gung-meta-output>
                   </span> <span class="text-lowercase pl-1" translate>AVAILABLE</span>) <br/>
                    </ng-container>
                  </div>
                </div>
              </ng-container>
            </td>
          </tr>
          </tbody>
        </table>
      </ng-template>
    </lib-gung-tab>
    <lib-gung-tab *ngIf="purchaseOrders && purchaseOrders.length > 0">
      <ng-template libGungTabTitle>{{ 'PURCHASE_ORDER_DETAILS' | translate }}</ng-template>
      <ng-template libGungTabContent>
        <table class="table table-striped">
          <thead class="table-dark">
          <tr>
            <th scope="col" translate>ORDER</th>
            <th scope="col" translate>QUANTITY</th>
            <th scope="col" translate>DELIVERY_DATE</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let row of purchaseOrders">
            <td>{{ row.orderId }}</td>
            <td>{{ parseFloat(row.quantity) | number:'':localeLang }} {{ (availability.unitOfMeasure || 'PCS') | translate }}</td>
            <td>{{ row.transactionDate | date: dateUtilService.dateFormat }}</td>
          </tr>
          </tbody>
        </table>
      </ng-template>
    </lib-gung-tab>
    <lib-gung-tab title="{{ 'CUSTOMER_ORDER_DETAILS' | translate }}" *ngIf="customerOrders.length > 0">
      <ng-template libGungTabContent>
        <table class="table table-striped">
          <thead class="table-dark">
          <tr>
            <th scope="col" translate>CUSTOMER_ID</th>
            <th scope="col" translate>CUSTOMER_NAME</th>
            <th scope="col" translate>ORDER</th>
            <th scope="col" translate>QUANTITY_REMAINING</th>
            <th scope="col" translate>DELIVERY_DATE</th>
          </tr>
          </thead>
          <tbody>
          <tr *ngFor="let row of customerOrders">
            <td>{{ row.customerId }}</td>
            <td>{{ row.customerName }}</td>
            <td>{{ row.orderId }}</td>
            <td>{{ parseFloat(row.quantity) - parseFloat(row.quantityDelivered || 0) | number:'':localeLang }} {{ (availability.unitOfMeasure || 'PCS') | translate }}</td>
            <td>{{ row.transactionDate | date: dateUtilService.dateFormat }}</td>
          </tr>
          </tbody>
        </table>
      </ng-template>
    </lib-gung-tab>
  </lib-gung-tabset>
</div>

<div class="modal-footer"></div>
